// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.71 7.8L1.74 13.97C1.65 14.25 1.75 14.35 2.03 14.26L8.2 12.29',
  'M8.2 12.29C7.18 12.62 5.49 11.72 4.44 10.29C3.39 8.86 3.37 7.44 4.4 7.11C5.42 6.78 7.11 7.68 8.16 9.11C9.21 10.54 9.23 11.96 8.2 12.29Z',
  'M7.14 4.98C7.32 4.06 8.38 3.82 8.3 2.94C8.28 2.68 8.11 2.47 7.97 2.31',
  'M9.25 6.75C9.65 6.35 10.75 5.9 11.3 4.7C11.85 3.5 12.95 3.05 13.35 2.65',
  'M11.02 8.86C11.94 8.68 12.18 7.62 13.06 7.7C13.32 7.72 13.53 7.89 13.69 8.03',
];
